//  import React, { useState, useEffect } from 'react';
// import { 
//   Phone, 
//   CheckCircle, 
//   Menu, 
//   X, 
//   ChevronDown, 
//   Facebook, 
//   Instagram, 
//   Linkedin 
// } from 'lucide-react';
// import logo from './assets/mqoelogo.png';
// import tajfront from './assets/tajweedfront.png';
// // Animation library for smooth effects
// import { motion, AnimatePresence } from 'framer-motion';

// const Tajweed = () => {
//   const [isMenuOpen, setIsMenuOpen] = useState(false);
//   const [isServicesOpen, setIsServicesOpen] = useState(false);
//   
//   // Exact Color Palette from your requirement
//   const BRAND_GREEN = '#28a745'; 
//   const DARK_GREEN = '#147a44';  
//   const BG_CREAM = '#fdf8e1';    
//   const COFFEE_BROWN = '#5d4a3e';

//   // Fonts & Icons loading
//   useEffect(() => {
//     const link = document.createElement('link');
//     link.href = 'https://fonts.googleapis.com/css2?family=Libre+Baskerville:wght@400;700&family=Montserrat:wght@400;500;600;700&family=Inter:wght@300;400;600;700;800&display=swap';
//     link.rel = 'stylesheet';
//     document.head.appendChild(link);

//     const fontAwesome = document.createElement('link');
//     fontAwesome.rel = 'stylesheet';
//     fontAwesome.href = 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.1/css/all.min.css';
//     document.head.appendChild(fontAwesome);
//   }, []);

//   const serviceOptions = [
//     { name: "Noorani Qaida", link: "#services" },
//     { name: "Tajweed-e-Quran", link: "#services" },
//     { name: "Basic Islamic Educations", link: "#services" }
//   ];

//   // Animation Variants
//   const fadeInUp = {
//     hidden: { opacity: 0, y: 30 },
//     visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } }
//   };

//   const staggerContainer = {
//     hidden: { opacity: 0 },
//     visible: {
//       opacity: 1,
//       transition: {
//         staggerChildren: 0.2
//       }
//     }
//   };

//   return (
//     <div className="min-h-screen text-[#333] overflow-x-hidden" style={{ backgroundColor: BG_CREAM, fontFamily: "'Inter', sans-serif" }}>
//       <style>{`
//         :root {
//             --primary-green: ${BRAND_GREEN};
//             --dark-green: ${DARK_GREEN};
//             --coffee: ${COFFEE_BROWN};
//         }

//         .nav-link {
//             font-weight: 600;
//             color: #1a3a2a;
//             transition: all 0.3s;
//             display: flex;
//             align-items: center;
//             gap: 4px;
//             cursor: pointer;
//             position: relative;
//         }

//         .nav-link::after {
//             content: '';
//             position: absolute;
//             bottom: -4px;
//             left: 0;
//             width: 0;
//             height: 2px;
//             background: var(--primary-green);
//             transition: width 0.3s;
//         }

//         .nav-link:hover::after {
//             width: 100%;
//         }

//         .dropdown-menu {
//             position: absolute;
//             top: 100%;
//             left: 0;
//             background: white;
//             min-width: 240px;
//             box-shadow: 0 15px 40px rgba(0,0,0,0.12);
//             border-radius: 12px;
//             padding: 12px 0;
//             opacity: 0;
//             visibility: hidden;
//             transform: translateY(15px);
//             transition: all 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
//             border-top: 4px solid var(--primary-green);
//             z-index: 50;
//         }

//         .group:hover .dropdown-menu {
//             opacity: 1;
//             visibility: visible;
//             transform: translateY(0);
//         }

//         .glow-effect {
//             position: relative;
//         }

//         .glow-effect::before {
//             content: '';
//             position: absolute;
//             inset: -10px;
//             background: radial-gradient(circle, rgba(40, 167, 69, 0.15) 0%, transparent 70%);
//             border-radius: inherit;
//             z-index: -1;
//             opacity: 0;
//             transition: opacity 0.3s;
//         }

//         .glow-effect:hover::before {
//             opacity: 1;
//         }

//         .floating {
//             animation: float 4s ease-in-out infinite;
//         }

//         @keyframes float {
//             0% { transform: translateY(0px); }
//             50% { transform: translateY(-15px); }
//             100% { transform: translateY(0px); }
//         }

//         .whatsapp-pulse {
//             animation: pulse-green 2s infinite;
//         }

//         @keyframes pulse-green {
//             0% { box-shadow: 0 0 0 0 rgba(37, 211, 102, 0.7); }
//             70% { box-shadow: 0 0 0 15px rgba(37, 211, 102, 0); }
//             100% { box-shadow: 0 0 0 0 rgba(37, 211, 102, 0); }
//         }

//         ::-webkit-scrollbar {
//             width: 8px;
//         }
//         ::-webkit-scrollbar-track {
//             background: #f1f1f1;
//         }
//         ::-webkit-scrollbar-thumb {
//             background: var(--primary-green);
//             border-radius: 10px;
//         }
//       `}</style>

//       {/* WhatsApp Floating Icon */}
//       <a 
//         href="https://wa.me/923024954689" 
//         target="_blank" 
//         rel="noopener noreferrer"
//         className="fixed bottom-8 right-6 z-[1001] whatsapp-pulse bg-[#25D366] p-4 rounded-full shadow-2xl cursor-pointer hover:scale-110 transition-transform active:scale-95"
//       >
//         <svg viewBox="0 0 24 24" width="32" height="32" fill="white">
//           <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L0 24l6.335-1.662c1.72.937 3.659 1.432 5.632 1.433h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
//         </svg>
//       </a>

//       {/* Header */}
//       <header className="py-4 px-6 lg:px-24 bg-white/90 backdrop-blur-md fixed top-0 left-0 right-0 z-[1000] shadow-sm">
//         <div className="max-w-7xl mx-auto flex justify-between items-center">
//           <motion.div 
//             initial={{ opacity: 0, x: -20 }}
//             animate={{ opacity: 1, x: 0 }}
//             className="flex items-center gap-3"
//           >
//             <div className="flex items-center">
//               {/* Replace with your actual logo img when ready */}
//               <img 
//           src={logo} 
//           alt="Madina Quran Online Education" 
//           className="h-16 w-auto object-contain" // Height ko logo ke design ke mutabiq 12 ya 14 rakhein
//         />
//             </div>
//             <span className="text-xl font-extrabold text-[#147a44] hidden lg:block tracking-tight">
//               Madina Quran Online Education
//             </span>
//           </motion.div>
//           
//           <nav className="hidden md:flex gap-10">
//             <a href="#" className="nav-link">Home</a>
//             
//             <div className="relative group">
//               <div className="nav-link cursor-pointer">
//                 Services <i className="fas fa-chevron-down text-[10px] ml-1"></i>
//               </div>
//               <div className="dropdown-menu">
//                 {serviceOptions.map((option, idx) => (
//                   <a key={idx} href={option.link} className="block px-6 py-3 text-[15px] font-medium text-gray-700 hover:bg-green-50 hover:text-green-600 transition-colors">
//                     {option.name}
//                   </a>
//                 ))}
//               </div>
//             </div>

//             <a href="#contact" className="nav-link">Contact Us</a>
//           </nav>

//           <motion.div 
//             whileTap={{ scale: 0.9 }}
//             className="md:hidden text-2xl cursor-pointer text-green-700" 
//             onClick={() => setIsMenuOpen(!isMenuOpen)}
//           >
//             <i className={isMenuOpen ? "fas fa-times" : "fas fa-bars"}></i>
//           </motion.div>
//         </div>
//       </header>

//       {/* Mobile Nav */}
//       <AnimatePresence>
//         {isMenuOpen && (
//           <motion.div 
//             initial={{ opacity: 0, height: 0 }}
//             animate={{ opacity: 1, height: 'auto' }}
//             exit={{ opacity: 0, height: 0 }}
//             className="md:hidden fixed top-[72px] left-0 right-0 bg-white p-5 flex flex-col gap-4 shadow-2xl z-[999] border-t overflow-hidden"
//           >
//             <a href="#" className="nav-link py-3 border-b border-gray-100" onClick={() => setIsMenuOpen(false)}>Home</a>
//             <div className="border-b border-gray-100">
//               <div className="nav-link py-3 justify-between" onClick={() => setIsServicesOpen(!isServicesOpen)}>
//                 Services <i className={`fas fa-chevron-${isServicesOpen ? 'up' : 'down'} text-sm`}></i>
//               </div>
//               {isServicesOpen && (
//                 <motion.div 
//                   initial={{ opacity: 0 }} 
//                   animate={{ opacity: 1 }} 
//                   className="pl-4 pb-4 flex flex-col space-y-3 mt-2"
//                 >
//                   {serviceOptions.map((option, idx) => (
//                     <a key={idx} href={option.link} className="text-sm font-medium text-gray-600 hover:text-green-600" onClick={() => setIsMenuOpen(false)}>
//                       {option.name}
//                     </a>
//                   ))}
//                 </motion.div>
//               )}
//             </div>
//             <a href="#contact" className="nav-link py-3" onClick={() => setIsMenuOpen(false)}>Contact Us</a>
//           </motion.div>
//         )}
//       </AnimatePresence>

//       {/* Main Content Area */}
//       <main className="max-w-6xl mx-auto px-6 lg:px-12 pt-28 pb-12">
//         <motion.h1 
//           initial={{ opacity: 0, y: 20 }}
//           animate={{ opacity: 1, y: 0 }}
//           className="text-[40px] md:text-[52px] font-bold text-[#222] mb-12 text-center md:text-left" 
//           style={{ fontFamily: "'Libre Baskerville', serif" }}
//         >
//           Tajweed Quran
//         </motion.h1>

//         {/* Hero Section */}
//         <motion.div 
//           initial={{ opacity: 0, scale: 0.95 }}
//           animate={{ opacity: 1, scale: 1 }}
//           transition={{ duration: 0.8 }}
//           className="relative mb-24 rounded-3xl overflow-hidden shadow-[0_20px_50px_rgba(0,0,0,0.15)] border-8 border-white group"
//         >
//           {/* Using a placeholder since local asset isn't available here, but structure is same */}
//           <div className="w-full h-[500px] bg-[#e0f2f1] overflow-hidden">
//              <img 
//                 src={tajfront}
//                 className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" 
//                 alt="Students Learning"
//               />
//           </div>
//           
//           <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
//           
//           <motion.div 
//             initial={{ y: 50, opacity: 0 }}
//             animate={{ y: 0, opacity: 1 }}
//             transition={{ delay: 0.5 }}
//             className="absolute inset-x-0 bottom-12 flex justify-center px-6"
//           >
//              <div 
//                className="text-white py-6 px-10 md:px-16 rounded-2xl text-center text-xl md:text-[34px] font-bold shadow-2xl backdrop-blur-md border border-white/20 floating"
//                style={{ backgroundColor: `${BRAND_GREEN}dd`, fontFamily: "'Montserrat', sans-serif" }}
//              >
//                Online Quran Teaching Tajweed
//              </div>
//           </motion.div>
//         </motion.div>

//         {/* Middle Heading */}
//         <motion.div 
//           initial="hidden"
//           whileInView="visible"
//           viewport={{ once: true }}
//           variants={fadeInUp}
//           className="text-center mb-20"
//         >
//           <h2 
//             className="text-3xl md:text-[40px] font-bold mb-8 leading-tight"
//             style={{ fontFamily: "'Libre Baskerville', serif", color: BRAND_GREEN }}
//           >
//             🌙 Tajweed Courses – Al Qirat Online Quran Academy
//           </h2>
//           <p className="text-[#555] text-xl leading-[1.8] max-w-4xl mx-auto font-medium opacity-90">
//             Reciting the Quran beautifully starts with correct pronunciation. Our Tajweed courses guide students in Pakistan and worldwide through live one-on-one lessons.
//           </p>
//         </motion.div>

//         {/* Info Grid */}
//         <motion.div 
//           variants={staggerContainer}
//           initial="hidden"
//           whileInView="visible"
//           viewport={{ once: true }}
//           className="grid md:grid-cols-2 gap-10 mb-10"
//         >
//           {/* Card 1 */}
//           <motion.div 
//             variants={fadeInUp}
//             className="bg-white p-10 pt-12 rounded-[2rem] shadow-[0_10px_40px_rgba(0,0,0,0.04)] border border-gray-100 glow-effect hover:shadow-green-100 hover:shadow-2xl transition-all duration-500"
//           >
//             <h3 
//               className="text-[26px] font-bold mb-6 flex items-center gap-3"
//               style={{ fontFamily: "'Libre Baskerville', serif", color: BRAND_GREEN }}
//             >
//               <i className="fas fa-lightbulb text-yellow-500"></i> Why Learn Tajweed Online?
//             </h3>
//             <div className="space-y-6 text-[#555] text-[16px] leading-[1.8] font-medium">
//               <p>Flexibility tops the list. Live anywhere in Pakistan and still access expert Tajweed teachers. No travel, no fixed hours. Sessions fit your calendar.</p>
//               <p>Personal attention drives results. One teacher, one student, means every mistake gets fixed instantly. Beginners start with basic makharij, advanced readers polish rules.</p>
//               <p>Interactive tools make learning stick. Teachers share screens to highlight rules, recordings let you replay tricky spots. Parents see results within months.</p>
//             </div>
//           </motion.div>

//           {/* Card 2 */}
//           <motion.div 
//             variants={fadeInUp}
//             className="bg-white p-10 pt-12 rounded-[2rem] shadow-[0_10px_40px_rgba(0,0,0,0.04)] border border-gray-100 glow-effect hover:shadow-green-100 hover:shadow-2xl transition-all duration-500"
//           >
//             <h3 
//               className="text-[26px] font-bold mb-6 flex items-center gap-3"
//               style={{ fontFamily: "'Libre Baskerville', serif", color: BRAND_GREEN }}
//             >
//               <i className="fas fa-book-open text-blue-500"></i> What is Tajweed?
//             </h3>
//             <p className="text-[#555] text-[16px] mb-8 leading-[1.8] font-medium">
//               Tajweed means beautifying recitation through rules. It covers articulation points, elongation, and nasal sounds. The Prophet Muhammad (PBUH) recited with perfect rhythm.
//             </p>
//             <ul className="space-y-5">
//               {[
//                 { t: 'Makharij', d: 'articulation points of letters' },
//                 { t: 'Harakat', d: 'short vowels Fatha, Kasra, Damma' },
//                 { t: 'Madd', d: 'elongation of sounds' },
//                 { t: 'Ghunnah', d: 'nasal hums for Noon & Meem' },
//                 { t: 'Qalqalah', d: 'bouncing of stopped letters' },
//               ].map((item, idx) => (
//                 <motion.li 
//                   key={item.t} 
//                   initial={{ x: -10, opacity: 0 }}
//                   whileInView={{ x: 0, opacity: 1 }}
//                   transition={{ delay: idx * 0.1 }}
//                   className="flex items-start gap-4 p-3 rounded-xl hover:bg-green-50 transition-colors"
//                 >
//                   <CheckCircle size={22} className="shrink-0 text-green-500" strokeWidth={3} />
//                   <span className="text-[16px]">
//                     <span className="font-bold text-[#333]">{item.t}</span> — <span className="text-[#555] font-medium">{item.d}</span>
//                   </span>
//                 </motion.li>
//               ))}
//             </ul>
//           </motion.div>
//         </motion.div>

//         {/* Row 2 Grid */}
//         <div className="grid md:grid-cols-2 gap-10 mb-10">
//           <motion.div 
//             initial={{ opacity: 0, x: -30 }}
//             whileInView={{ opacity: 1, x: 0 }}
//             viewport={{ once: true }}
//             className="bg-white p-10 pt-12 rounded-[2rem] shadow-[0_10px_40px_rgba(0,0,0,0.04)] border border-gray-100"
//           >
//             <h3 
//               className="text-[26px] font-bold mb-6"
//               style={{ fontFamily: "'Libre Baskerville', serif", color: BRAND_GREEN }}
//             >
//               How Tajweed Enhances Recitation
//             </h3>
//             <p className="text-[#555] text-[16px] leading-[1.8] mb-6 font-medium">
//               Tajweed shapes every letter leaving the tongue, stretching vowels, and pausing exactly where intended. Teachers demonstrate live, practice immediately, and within weeks recitations flow smoothly.
//             </p>
//             <p className="text-[#555] text-[16px] leading-[1.8] font-medium">
//               Family prayers gain harmony. Children lead prayers without stumbling; adults feel rhythm in their chest, and listeners are moved by the beauty.
//             </p>
//           </motion.div>

//           <motion.div 
//             initial={{ opacity: 0, x: 30 }}
//             whileInView={{ opacity: 1, x: 0 }}
//             viewport={{ once: true }}
//             className="bg-white p-10 pt-12 rounded-[2rem] shadow-[0_10px_40px_rgba(0,0,0,0.04)] border border-gray-100"
//           >
//             <h3 
//               className="text-[26px] font-bold mb-6"
//               style={{ fontFamily: "'Libre Baskerville', serif", color: BRAND_GREEN }}
//             >
//               Who Should Learn Tajweed?
//             </h3>
//             <p className="text-[#555] text-[16px] leading-[1.8] font-medium">
//               Beginners, housewives, working adults, teens, retirees, and Hifz students. Kids from age 7 join with easy-to-follow rules. Adults refine rusty recitations. Everyone learns at their own pace in a comfortable environment.
//             </p>
//             <div className="mt-8 grid grid-cols-2 gap-4">
//                <div className="p-4 bg-green-50 rounded-2xl text-center border border-green-100">
//                   <div className="text-2xl font-bold text-green-700">7+</div>
//                   <div className="text-xs font-bold uppercase text-green-600">Min Age</div>
//                </div>
//                <div className="p-4 bg-green-50 rounded-2xl text-center border border-green-100">
//                   <div className="text-2xl font-bold text-green-700">1-on-1</div>
//                   <div className="text-xs font-bold uppercase text-green-600">Lessons</div>
//                </div>
//             </div>
//           </motion.div>
//         </div>

//         {/* Contact Block */}
//         <motion.div 
//           initial={{ opacity: 0, y: 30 }}
//           whileInView={{ opacity: 1, y: 0 }}
//           viewport={{ once: true }}
//           className="bg-white p-10 md:p-14 rounded-[2.5rem] shadow-[0_20px_60px_rgba(0,0,0,0.06)] border border-gray-100 max-w-3xl mx-auto overflow-hidden relative"
//         >
//           <div className="absolute top-0 right-0 w-32 h-32 bg-green-500/10 rounded-bl-full"></div>
//           
//           <h3 
//             className="text-[28px] md:text-[32px] font-bold mb-6 leading-tight"
//             style={{ fontFamily: "'Libre Baskerville', serif", color: BRAND_GREEN }}
//           >
//             Contact Al Qirat Online Quran Academy
//           </h3>
//           <p className="text-[#555] text-[17px] leading-[1.8] mb-8 font-medium">
//             Phone calls connect you directly to our team for schedules and course inquiries. WhatsApp is available for quick messages. Responses are fast even at odd hours.
//           </p>
//           <div className="mb-10 p-6 bg-gray-50 rounded-2xl border-l-4 border-green-500">
//             <p className="text-[17px] font-bold text-[#333] flex items-center gap-3">
//                <Phone size={20} className="text-green-600" />
//                Phone: <span className="text-[#333] font-medium">+92 315 5141289</span>
//             </p>
//           </div>
//           <motion.button 
//             whileHover={{ scale: 1.03, boxShadow: "0 10px 25px rgba(40, 167, 69, 0.3)" }}
//             whileTap={{ scale: 0.98 }}
//             className="w-full md:w-auto text-white px-12 py-5 rounded-2xl font-bold text-[18px] tracking-wide transition-all shadow-xl bg-gradient-to-r from-[#28a745] to-[#147a44]"
//           >
//             Book Free Trial / Contact Us
//           </motion.button>
//         </motion.div>
//       </main>

//       {/* Footer */}
//       <footer className="bg-white border-t border-gray-100 mt-24">
//         <div className="max-w-7xl mx-auto px-8 lg:px-12 py-20 grid md:grid-cols-3 gap-16 lg:gap-24">
//           <div className="space-y-8">
//             <div className="flex items-center gap-3">
//                <div className="w-10 h-10 bg-green-600 rotate-45 flex items-center justify-center rounded-lg shadow-lg">
//                   <span className="rotate-[-45deg] text-[10px] font-black text-white">ALQ</span>
//                </div>
//                <span className="text-2xl font-black tracking-tighter" style={{ color: BRAND_GREEN }}>AL QIRAT</span>
//             </div>
//             <p className="text-[#888] text-[15px] leading-[1.9] font-medium">
//               Online Quran teaching Pakistan offers modern teaching methods for all non-Arabic speakers Muslims who want to learn Arabic, & Quran Islamic studies.
//             </p>
//           </div>

//           <div className="grid grid-cols-2 gap-8">
//             <div>
//               <h4 className="font-bold text-[#333] mb-8 text-[13px] uppercase tracking-[0.2em]">Useful Links</h4>
//               <ul className="space-y-5 text-[15px] text-[#888] font-semibold">
//                 <li><a href="#" className="hover:text-green-600 transition-colors">About Us</a></li>
//                 <li><a href="#" className="hover:text-green-600 transition-colors">Feature</a></li>
//                 <li><a href="#" className="hover:text-green-600 transition-colors">Services</a></li>
//               </ul>
//             </div>
//             <div className="pt-[52px]">
//               <ul className="space-y-5 text-[15px] text-[#888] font-semibold">
//                 <li><a href="#" className="hover:text-green-600 transition-colors">Blog</a></li>
//                 <li><a href="#" className="hover:text-green-600 transition-colors">Contact Us</a></li>
//                 <li><a href="#" className="hover:text-green-600 transition-colors">Fees</a></li>
//               </ul>
//             </div>
//           </div>

//           <div>
//             <h4 className="font-bold text-[#333] mb-8 text-[13px] uppercase tracking-[0.2em]">Follow Us</h4>
//             <p className="text-[#888] text-[15px] mb-8 font-medium">Don't miss our future updates! Get Subscribed Today!</p>
//             <div className="flex gap-4">
//               {[Facebook, Instagram, Linkedin].map((Icon, i) => (
//                 <motion.a 
//                   key={i} 
//                   whileHover={{ y: -5, backgroundColor: BRAND_GREEN, color: '#fff', borderColor: BRAND_GREEN }}
//                   href="#" 
//                   className="w-12 h-12 border border-gray-200 rounded-2xl flex items-center justify-center text-[#999] transition-all bg-white"
//                 >
//                   <Icon size={22} />
//                 </motion.a>
//               ))}
//             </div>
//           </div>
//         </div>

//         <div className="bg-[#5d4a3e] py-8 text-center relative overflow-hidden">
//           <div className="absolute inset-0 bg-white/5 opacity-10"></div>
//           <p className="text-white text-[13px] font-bold tracking-widest relative z-10 opacity-90">
//             © 2022-2025 AL QIRAT ONLINE ACADEMY. ALL RIGHTS RESERVED
//           </p>
//         </div>
//       </footer>
//     </div>
//   );
// };

// export default Tajweed; 








import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  Phone, 
  CheckCircle, 
  Menu, 
  X, 
  ChevronDown, 
  Facebook, 
  Instagram, 
  Linkedin 
} from 'lucide-react';
import logo from './assets/mqoelogo.png';
import tajfront from './assets/tajweedfront.png';
// Animation library for smooth effects
import { motion, AnimatePresence } from 'framer-motion';

const Tajweed = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isServicesOpen, setIsServicesOpen] = useState(false);

  const navigate = useNavigate();
  
    const handleContactClick = () => {
      navigate("/#contact"); // Home page + hash
    };
    
  
  // Exact Color Palette from your requirement
  const BRAND_GREEN = '#28a745'; 
  const DARK_GREEN = '#147a44';  
  const BG_CREAM = '#fdf8e1';    
  const COFFEE_BROWN = '#5d4a3e';

  // Fonts & Icons loading
  useEffect(() => {
    const link = document.createElement('link');
    link.href = 'https://fonts.googleapis.com/css2?family=Libre+Baskerville:wght@400;700&family=Montserrat:wght@400;500;600;700&family=Inter:wght@300;400;600;700;800&display=swap';
    link.rel = 'stylesheet';
    document.head.appendChild(link);

    const fontAwesome = document.createElement('link');
    fontAwesome.rel = 'stylesheet';
    fontAwesome.href = 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.1/css/all.min.css';
    document.head.appendChild(fontAwesome);
  }, []);

  const serviceOptions = [
    { name: "Noorani Qaida", link: "/noorani" },
    { name: "Tajweed-e-Quran", link: "/tajweed" },
    { name: "Basic Islamic Educations", link: "/all" }
  ];

  // Animation Variants
  const fadeInUp = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } }
  };

  const staggerContainer = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  return (
    <div className="min-h-screen text-[#333] overflow-x-hidden" style={{ backgroundColor: BG_CREAM, fontFamily: "'Inter', sans-serif" }}>
      <style>{`
        :root {
            --primary-green: ${BRAND_GREEN};
            --dark-green: ${DARK_GREEN};
            --coffee: ${COFFEE_BROWN};
        }

        .nav-link {
            font-weight: 600;
            color: #1a3a2a;
            transition: all 0.3s;
            display: flex;
            align-items: center;
            gap: 4px;
            cursor: pointer;
            position: relative;
        }

        .nav-link::after {
            content: '';
            position: absolute;
            bottom: -4px;
            left: 0;
            width: 0;
            height: 2px;
            background: var(--primary-green);
            transition: width 0.3s;
        }

        .nav-link:hover::after {
            width: 100%;
        }

        .dropdown-menu {
            position: absolute;
            top: 100%;
            left: 0;
            background: white;
            min-width: 240px;
            box-shadow: 0 15px 40px rgba(0,0,0,0.12);
            border-radius: 12px;
            padding: 12px 0;
            opacity: 0;
            visibility: hidden;
            transform: translateY(15px);
            transition: all 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
            border-top: 4px solid var(--primary-green);
            z-index: 50;
        }

        .group:hover .dropdown-menu {
            opacity: 1;
            visibility: visible;
            transform: translateY(0);
        }

        .glow-effect {
            position: relative;
        }

        .glow-effect::before {
            content: '';
            position: absolute;
            inset: -10px;
            background: radial-gradient(circle, rgba(40, 167, 69, 0.15) 0%, transparent 70%);
            border-radius: inherit;
            z-index: -1;
            opacity: 0;
            transition: opacity 0.3s;
        }

        .glow-effect:hover::before {
            opacity: 1;
        }

        .floating {
            animation: float 4s ease-in-out infinite;
        }

        @keyframes float {
            0% { transform: translateY(0px); }
            50% { transform: translateY(-15px); }
            100% { transform: translateY(0px); }
        }

        .whatsapp-pulse {
            animation: pulse-green 2s infinite;
        }

        @keyframes pulse-green {
            0% { box-shadow: 0 0 0 0 rgba(37, 211, 102, 0.7); }
            70% { box-shadow: 0 0 0 15px rgba(37, 211, 102, 0); }
            100% { box-shadow: 0 0 0 0 rgba(37, 211, 102, 0); }
        }

        ::-webkit-scrollbar {
            width: 8px;
        }
        ::-webkit-scrollbar-track {
            background: #f1f1f1;
        }
        ::-webkit-scrollbar-thumb {
            background: var(--primary-green);
            border-radius: 10px;
        }
      `}</style>

      {/* WhatsApp Floating Icon */}
      <a 
        href="https://wa.me/923024954689" 
        target="_blank" 
        rel="noopener noreferrer"
        className="fixed bottom-8 right-6 z-[1001] whatsapp-pulse bg-[#25D366] p-4 rounded-full shadow-2xl cursor-pointer hover:scale-110 transition-transform active:scale-95"
      >
        <svg viewBox="0 0 24 24" width="32" height="32" fill="white">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L0 24l6.335-1.662c1.72.937 3.659 1.432 5.632 1.433h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
        </svg>
      </a>

      {/* Header */}
      <header className="py-4 px-6 lg:px-24 bg-white/90 backdrop-blur-md fixed top-0 left-0 right-0 z-[1000] shadow-sm">
        <div className="max-w-7xl mx-auto flex justify-between items-center">
          <motion.div 
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            className="flex items-center gap-3"
          >
            <div className="flex items-center">
              {/* Replace with your actual logo img when ready */}
              <img 
          src={logo} 
          alt="Madina Quran Online Education" 
          className="h-16 w-auto object-contain" // Height ko logo ke design ke mutabiq 12 ya 14 rakhein
        />
            </div>
            <span className="text-sm md:text-lg lg:text-xl font-extrabold text-[#147a44]">
              Madina Quran Online Education
            </span>
            <div className="hidden md:flex items-center gap-4 ml-6">
      <a href="https://www.facebook.com/people/Jamia-Madina-Tul-Quran-Online-Academy/61581687654772/?rdid=a5sb3u7e1r2ckVRz&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1G7EYvJyud%2F" className="text-green-600 hover:text-[#147a44] transition text-lg">
        <i className="fab fa-facebook-f"></i>
      </a>
      <a href="#" className="text-green-600 hover:text-[#147a44] transition text-lg">
        <i className="fab fa-instagram"></i>
      </a>
      <a href="https://wa.me/+923155141289" target="_blank" rel="noopener noreferrer"  className="text-green-600 hover:text-[#147a44] transition text-lg">
        <i className="fab fa-whatsapp"></i>
      </a>
    </div>
          </motion.div>
          
          <nav className="hidden md:flex gap-10">
            <a href="/" className="nav-link">Home</a>
            
            <div className="relative group">
              <div className="nav-link cursor-pointer">
                Services <i className="fas fa-chevron-down text-[10px] ml-1"></i>
              </div>
              <div className="dropdown-menu">
                {serviceOptions.map((option, idx) => (
                  <a key={idx} href={option.link} className="block px-6 py-3 text-[15px] font-medium text-gray-700 hover:bg-green-50 hover:text-green-600 transition-colors">
                    {option.name}
                  </a>
                ))}
              </div>
            </div>

            <a href="/#contact" className="nav-link">Contact Us</a>
          </nav>

          <motion.div 
            whileTap={{ scale: 0.9 }}
            className="md:hidden text-2xl cursor-pointer text-green-700" 
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <i className={isMenuOpen ? "fas fa-times" : "fas fa-bars"}></i>
          </motion.div>
        </div>
      </header>

      {/* Mobile Nav */}
      <AnimatePresence>
        {isMenuOpen && (
          <motion.div 
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            className="md:hidden fixed top-[72px] left-0 right-0 bg-white p-5 flex flex-col gap-4 shadow-2xl z-[999] border-t overflow-hidden"
          >
            <a href="#" className="nav-link py-3 border-b border-gray-100" onClick={() => setIsMenuOpen(false)}>Home</a>
            <div className="border-b border-gray-100">
              <div className="nav-link py-3 justify-between" onClick={() => setIsServicesOpen(!isServicesOpen)}>
                Services <i className={`fas fa-chevron-${isServicesOpen ? 'up' : 'down'} text-sm`}></i>
              </div>
              {isServicesOpen && (
                <motion.div 
                  initial={{ opacity: 0 }} 
                  animate={{ opacity: 1 }} 
                  className="pl-4 pb-4 flex flex-col space-y-3 mt-2"
                >
                  {serviceOptions.map((option, idx) => (
                    <a key={idx} href={option.link} className="text-sm font-medium text-gray-600 hover:text-green-600" onClick={() => setIsMenuOpen(false)}>
                      {option.name}
                    </a>
                  ))}
                </motion.div>
              )}
            </div>
            <a href="#contact" className="nav-link py-3" onClick={() => setIsMenuOpen(false)}>Contact Us</a>

             {/* Social Media Icons (Mobile) */}
          <div className="flex gap-4 pt-3">
            <a href="https://www.facebook.com/people/Jamia-Madina-Tul-Quran-Online-Academy/61581687654772/?rdid=a5sb3u7e1r2ckVRz&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1G7EYvJyud%2F"><i className="fab fa-facebook-f text-gray-600"></i></a>
            <a href="#"><i className="fab fa-instagram text-gray-600"></i></a>
            <a href="#"><i className="fab fa-whatsapp text-gray-600"></i></a>
          </div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Main Content Area */}
      <main className="max-w-6xl mx-auto px-6 lg:px-12 pt-28 pb-12">
        <motion.h1 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-[40px] md:text-[52px] font-bold text-[#222] mb-12 text-center md:text-left" 
          style={{ fontFamily: "'Libre Baskerville', serif" }}
        >
          Tajweed Quran
        </motion.h1>

        {/* Hero Section */}
        <motion.div 
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8 }}
          className="relative mb-24 rounded-3xl overflow-hidden shadow-[0_20px_50px_rgba(0,0,0,0.15)] border-8 border-white group"
        >
          {/* Using a placeholder since local asset isn't available here, but structure is same */}
          <div className="w-full h-[500px] bg-[#e0f2f1] overflow-hidden">
             <img 
                src={tajfront}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" 
                alt="Students Learning"
              />
          </div>
          
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
          
          <motion.div 
            initial={{ y: 50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.5 }}
            className="absolute inset-x-0 bottom-12 flex justify-center px-6"
          >
             <div 
               className="text-white py-6 px-10 md:px-16 rounded-2xl text-center text-xl md:text-[34px] font-bold shadow-2xl backdrop-blur-md border border-white/20 floating"
               style={{ backgroundColor: `${BRAND_GREEN}dd`, fontFamily: "'Montserrat', sans-serif" }}
             >
               Online Quran Teaching Tajweed
             </div>
          </motion.div>
        </motion.div>

        {/* Middle Heading */}
        <motion.div 
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={fadeInUp}
          className="text-center mb-20"
        >
          <h2 
            className="text-3xl md:text-[40px] font-bold mb-8 leading-tight"
            style={{ fontFamily: "'Libre Baskerville', serif", color: BRAND_GREEN }}
          >
            🌙 Tajweed Courses – Al Qirat Online Quran Academy
          </h2>
          <p className="text-[#555] text-xl leading-[1.8] max-w-4xl mx-auto font-medium opacity-90">
            Reciting the Quran beautifully starts with correct pronunciation. Our Tajweed courses guide students in Pakistan and worldwide through live one-on-one lessons.
          </p>
        </motion.div>

        {/* Info Grid */}
        <motion.div 
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="grid md:grid-cols-2 gap-10 mb-10"
        >
          {/* Card 1 */}
          <motion.div 
            variants={fadeInUp}
            className="bg-white p-10 pt-12 rounded-[2rem] shadow-[0_10px_40px_rgba(0,0,0,0.04)] border border-gray-100 glow-effect hover:shadow-green-100 hover:shadow-2xl transition-all duration-500"
          >
            <h3 
              className="text-[26px] font-bold mb-6 flex items-center gap-3"
              style={{ fontFamily: "'Libre Baskerville', serif", color: BRAND_GREEN }}
            >
              <i className="fas fa-lightbulb text-yellow-500"></i> Why Learn Tajweed Online?
            </h3>
            <div className="space-y-6 text-[#555] text-[16px] leading-[1.8] font-medium">
              <p>Flexibility tops the list. Live anywhere in Pakistan and still access expert Tajweed teachers. No travel, no fixed hours. Sessions fit your calendar.</p>
              <p>Personal attention drives results. One teacher, one student, means every mistake gets fixed instantly. Beginners start with basic makharij, advanced readers polish rules.</p>
              <p>Interactive tools make learning stick. Teachers share screens to highlight rules, recordings let you replay tricky spots. Parents see results within months.</p>
            </div>
          </motion.div>

          {/* Card 2 */}
          <motion.div 
            variants={fadeInUp}
            className="bg-white p-10 pt-12 rounded-[2rem] shadow-[0_10px_40px_rgba(0,0,0,0.04)] border border-gray-100 glow-effect hover:shadow-green-100 hover:shadow-2xl transition-all duration-500"
          >
            <h3 
              className="text-[26px] font-bold mb-6 flex items-center gap-3"
              style={{ fontFamily: "'Libre Baskerville', serif", color: BRAND_GREEN }}
            >
              <i className="fas fa-book-open text-yellow-500"></i> What is Tajweed?
            </h3>
            <p className="text-[#555] text-[16px] mb-8 leading-[1.8] font-medium">
              Tajweed means beautifying recitation through rules. It covers articulation points, elongation, and nasal sounds. The Prophet Muhammad (PBUH) recited with perfect rhythm.
            </p>
            <ul className="space-y-5">
              {[
                { t: 'Makharij', d: 'articulation points of letters' },
                { t: 'Harakat', d: 'short vowels Fatha, Kasra, Damma' },
                { t: 'Madd', d: 'elongation of sounds' },
                { t: 'Ghunnah', d: 'nasal hums for Noon & Meem' },
                { t: 'Qalqalah', d: 'bouncing of stopped letters' },
              ].map((item, idx) => (
                <motion.li 
                  key={item.t} 
                  initial={{ x: -10, opacity: 0 }}
                  whileInView={{ x: 0, opacity: 1 }}
                  transition={{ delay: idx * 0.1 }}
                  className="flex items-start gap-4 p-3 rounded-xl hover:bg-green-50 transition-colors"
                >
                  <CheckCircle size={22} className="shrink-0 text-green-500" strokeWidth={3} />
                  <span className="text-[16px]">
                    <span className="font-bold text-[#333]">{item.t}</span> — <span className="text-[#555] font-medium">{item.d}</span>
                  </span>
                </motion.li>
              ))}
            </ul>
          </motion.div>
        </motion.div>

        {/* Row 2 Grid */}
        <div className="grid md:grid-cols-2 gap-10 mb-10">
          <motion.div 
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="bg-white p-10 pt-12 rounded-[2rem] shadow-[0_10px_40px_rgba(0,0,0,0.04)] border border-gray-100"
          >
            <h3 
              className="text-[26px] font-bold mb-6"
              style={{ fontFamily: "'Libre Baskerville', serif", color: BRAND_GREEN }}
            >
              How Tajweed Enhances Recitation
            </h3>
            <p className="text-[#555] text-[16px] leading-[1.8] mb-6 font-medium">
              Tajweed shapes every letter leaving the tongue, stretching vowels, and pausing exactly where intended. Teachers demonstrate live, practice immediately, and within weeks recitations flow smoothly.
            </p>
            <p className="text-[#555] text-[16px] leading-[1.8] font-medium">
              Family prayers gain harmony. Children lead prayers without stumbling; adults feel rhythm in their chest, and listeners are moved by the beauty.
            </p>
          </motion.div>

          <motion.div 
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="bg-white p-10 pt-12 rounded-[2rem] shadow-[0_10px_40px_rgba(0,0,0,0.04)] border border-gray-100"
          >
            <h3 
              className="text-[26px] font-bold mb-6"
              style={{ fontFamily: "'Libre Baskerville', serif", color: BRAND_GREEN }}
            >
              Who Should Learn Tajweed?
            </h3>
            <p className="text-[#555] text-[16px] leading-[1.8] font-medium">
              Beginners, housewives, working adults, teens, retirees, and Hifz students. Kids from age 7 join with easy-to-follow rules. Adults refine rusty recitations. Everyone learns at their own pace in a comfortable environment.
            </p>
            <div className="mt-8 grid grid-cols-2 gap-4">
               <div className="p-4 bg-green-50 rounded-2xl text-center border border-green-100">
                  <div className="text-2xl font-bold text-green-700">7+</div>
                  <div className="text-xs font-bold uppercase text-green-600">Min Age</div>
               </div>
               <div className="p-4 bg-green-50 rounded-2xl text-center border border-green-100">
                  <div className="text-2xl font-bold text-green-700">1-on-1</div>
                  <div className="text-xs font-bold uppercase text-green-600">Lessons</div>
               </div>
            </div>
          </motion.div>
        </div>

        {/* Contact Block */}
        <motion.div 
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="bg-white p-10 md:p-14 rounded-[2.5rem] shadow-[0_20px_60px_rgba(0,0,0,0.06)] border border-gray-100 max-w-3xl mx-auto overflow-hidden relative"
        >
          <div className="absolute top-0 right-0 w-32 h-32 bg-green-500/10 rounded-bl-full"></div>
          
          <h3 
            className="text-[28px] md:text-[32px] font-bold mb-6 leading-tight"
            style={{ fontFamily: "'Libre Baskerville', serif", color: BRAND_GREEN }}
          >
            Contact Madina Quran Online Education
          </h3>
          <p className="text-[#555] text-[17px] leading-[1.8] mb-8 font-medium">
            Phone calls connect you directly to our team for schedules and course inquiries. WhatsApp is available for quick messages. Responses are fast even at odd hours.
          </p>
          <div className="mb-10 p-6 bg-gray-50 rounded-2xl border-l-4 border-green-500">
            <p className="text-[17px] font-bold text-[#333] flex items-center gap-3">
               <Phone size={20} className="text-green-600" />
               Phone: <span className="text-[#333] font-medium">+92 315 5141289</span>
            </p>
          </div>
          <motion.button
  onClick={handleContactClick}
  whileHover={{ scale: 1.03, boxShadow: "0 10px 25px rgba(40, 167, 69, 0.3)" }}
  whileTap={{ scale: 0.98 }}
  className="inline-block w-full md:w-auto text-white px-12 py-5 rounded-2xl font-bold text-[18px] tracking-wide transition-all shadow-xl bg-gradient-to-r from-[#28a745] to-[#147a44]"
>
  Book Free Trial / Contact Us
</motion.button>
        </motion.div>
      </main>

      {/* Footer */}
      {/* <footer className="bg-white border-t border-gray-100 mt-24">
        <div className="max-w-7xl mx-auto px-8 lg:px-12 py-20 grid md:grid-cols-3 gap-16 lg:gap-24">
          <div className="space-y-8">
            <div className="flex items-center gap-3">
               <div className="w-10 h-10 bg-green-600 rotate-45 flex items-center justify-center rounded-lg shadow-lg">
                  <span className="rotate-[-45deg] text-[10px] font-black text-white">ALQ</span>
               </div>
               <span className="text-2xl font-black tracking-tighter" style={{ color: BRAND_GREEN }}>AL QIRAT</span>
            </div>
            <p className="text-[#888] text-[15px] leading-[1.9] font-medium">
              Online Quran teaching Pakistan offers modern teaching methods for all non-Arabic speakers Muslims who want to learn Arabic, & Quran Islamic studies.
            </p>
          </div>

          <div className="grid grid-cols-2 gap-8">
            <div>
              <h4 className="font-bold text-[#333] mb-8 text-[13px] uppercase tracking-[0.2em]">Useful Links</h4>
              <ul className="space-y-5 text-[15px] text-[#888] font-semibold">
                <li><a href="#" className="hover:text-green-600 transition-colors">About Us</a></li>
                <li><a href="#" className="hover:text-green-600 transition-colors">Feature</a></li>
                <li><a href="#" className="hover:text-green-600 transition-colors">Services</a></li>
              </ul>
            </div>
            <div className="pt-[52px]">
              <ul className="space-y-5 text-[15px] text-[#888] font-semibold">
                <li><a href="#" className="hover:text-green-600 transition-colors">Blog</a></li>
                <li><a href="#" className="hover:text-green-600 transition-colors">Contact Us</a></li>
                <li><a href="#" className="hover:text-green-600 transition-colors">Fees</a></li>
              </ul>
            </div>
          </div>

          <div>
            <h4 className="font-bold text-[#333] mb-8 text-[13px] uppercase tracking-[0.2em]">Follow Us</h4>
            <p className="text-[#888] text-[15px] mb-8 font-medium">Don't miss our future updates! Get Subscribed Today!</p>
            <div className="flex gap-4">
              {[Facebook, Instagram, Linkedin].map((Icon, i) => (
                <motion.a 
                  key={i} 
                  whileHover={{ y: -5, backgroundColor: BRAND_GREEN, color: '#fff', borderColor: BRAND_GREEN }}
                  href="#" 
                  className="w-12 h-12 border border-gray-200 rounded-2xl flex items-center justify-center text-[#999] transition-all bg-white"
                >
                  <Icon size={22} />
                </motion.a>
              ))}
            </div>
          </div>
        </div>

        <div className="bg-[#5d4a3e] py-8 text-center relative overflow-hidden">
          <div className="absolute inset-0 bg-white/5 opacity-10"></div>
          <p className="text-white text-[13px] font-bold tracking-widest relative z-10 opacity-90">
            © 2022-2025 AL QIRAT ONLINE ACADEMY. ALL RIGHTS RESERVED
          </p>
        </div>
      </footer> */}
    </div>
  );
};

export default Tajweed;